export default __webpack_public_path__ + "static/media/My project (83) 1 (3).9e52a23c.png";